import * as React from 'react';
import { OptionDescription, OptionsCheckbox } from 'owa-options-controls';
import ChangeNotificationStatus from 'owa-service/lib/contract/ChangeNotificationStatus';
import ColoredBulletOption from './ColoredBulletOption';
import { ICheckboxProps } from 'office-ui-fabric-react/lib/Checkbox';
import { Label } from 'office-ui-fabric-react/lib/Label';
import SharedCalendarViewState from '../data/store/schema/SharedCalendarViewState';
import getStore from '../data/store/store';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import updateChangeNotificationStatusInCurrentState from '../data/mutators/updateChangeNotificationStatusInCurrentState';

const styles = require('./CalendarUpdatesSection.scss');

/**
 *  This renders a list of notification subscription settings for shared calendars.
 */
export default observer(function CalendarUpdatesSection() {
    let { calendars, currentState } = getStore();
    return (
        <div className={styles.calendarUpdatesWrapper}>
            <Label className={styles.sectionTitle}>{strings.optionTitle_calendarUpdates}</Label>
            <OptionDescription className={styles.sectionMessage}>
                {strings.options_sharedCalendars_CalendarUpdatesSectionMessage}
            </OptionDescription>
            <div className={styles.sectionCheckboxesMessage}>
                {strings.options_sharedCalendars_CalendarUpdatesUserChoicesSectionMessage}
            </div>
            {getCalendarUpdates(calendars).map(sharedCalendar => {
                let checked =
                    currentState[sharedCalendar.folderId] == ChangeNotificationStatus.Enabled;
                let label = sharedCalendar.calendarName;

                return (
                    <OptionsCheckbox
                        key={sharedCalendar.folderId}
                        checked={checked}
                        onChange={onNotificationSettingChange(sharedCalendar.folderId)}
                        label={label}
                        color={sharedCalendar.hexColorString}
                        onRenderLabel={onRenderLabel}
                    />
                );
            })}
        </div>
    );
});

const getCalendarUpdates = (calendars: SharedCalendarViewState[]) => {
    return (
        calendars &&
        calendars.filter((calendar: SharedCalendarViewState) => {
            return calendar.canEnableChangeNotifications;
        })
    );
};

const onNotificationSettingChange = (folderId: string) => (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean
) => {
    updateChangeNotificationStatusInCurrentState(folderId, checked);
};

/**
 * Custom renderer for checkbox as a colored bullet needs to be shown
 */
const onRenderLabel = (props: ICheckboxProps): JSX.Element => {
    return (
        <ColoredBulletOption
            color={props.color}
            label={props.label}
            iconClassName={styles.coloredBullet}
        />
    );
};
